import { EntityService } from '../../../../service/EntityService';

export class TenantCompanyService extends EntityService {

  static entity = 'api/app/tenant-company';

}
